import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookieService);
  const sessionId = cookieService.get('session_id');

  let authReq = req;

  if (sessionId) {
    
    authReq = req.clone({
      withCredentials: true,
      headers: req.headers.set('X-Session-ID', sessionId)
    });
  } else {
    // Still include credentials to allow server to set cookies during login
    authReq = req.clone({ withCredentials: true });
  }

  return next(authReq);
};